// react
import React, { Fragment, useState, useEffect } from "react";
// store
import { activityService } from "../../../../store/services/ServiceActivity";
import { addressService } from "../../../../store/services/ServiceAddress";
import { userProfileService } from "../../../../store/services/ServiceUserProfile";
import { LOADING_TIME } from "../../../../store/config";
import {
    setSelectOptions,
    setSelectOptionsActivities,
} from "../../../../store/services/helpers/functions";
// components
import HeaderTitle from "../../../../components/others/HeaderTitle";
import ActivityForm from "./ActivityForm";
import Loading from "../../../../components/others/Loading";
// others
import { GAPageView, initGA } from "../../../../index";
import { useActingAsUser } from "../../../../store/hooks/useActingAsUser";

// component
function ActivityAdd() {
    const { actAsUser } = useActingAsUser();
    // state
    const [isLoading, setIsLoading] = useState(false);
    const [activities, setActivities] = useState([]);
    const [addresses, setAddresses] = useState([]);
    const [country, setCountry] = useState([]);

    // Google analytics
    useEffect(() => {
        initGA();
        GAPageView();
    }, []);

    // fetch data
    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            const resultActivities = await activityService.getActivities(
                "?status=true",
                actAsUser
            );
            setActivities(resultActivities.response);

            const resultAddresses = await addressService.getAddresses(actAsUser);
            setAddresses(resultAddresses);

            const profile = await userProfileService.getUserProfile(actAsUser);
            if (profile[0]) {
                setCountry(profile[0].country);
            }

            setTimeout(function () {
                setIsLoading(false);
            }, LOADING_TIME);
        };

        fetchData();
        // eslint-disable-next-line
    }, []);

    // set options for dropdown form field - activities, addresses
    const activitiesOptions = setSelectOptionsActivities(activities, country);
    const addressesOptions = setSelectOptions(addresses);

    // template
    return (
        <Fragment>
            {isLoading ? (
                <Loading />
            ) : (
                <>
                    <HeaderTitle title="Pridať aktivitu" />
                    <section>
                        <ActivityForm
                            data={[]}
                            activities={activitiesOptions}
                            addresses={addressesOptions}
                            country={country}
                        />
                    </section>
                </>
            )}
        </Fragment>
    );
}

export default ActivityAdd;
